var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.showAppBar)?_c('app-header',{attrs:{"auth":_vm.ProviderAuth}}):_vm._e(),_c('v-main',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('router-view',{attrs:{"auth":_vm.ProviderAuth}}),_c('app-toast')],1)],1),_c('app-bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }